import { useOidc, useOidcAccessToken } from "@axa-fr/react-oidc";
import { useUser } from "../contexts/UserContext";

/**
 * Custom hook for authentication using Keycloak OIDC
 *
 * User info comes from Django's /api/user/ endpoint via UserContext
 * to include app-specific fields not present in the Keycloak token.
 */
const useAuth = () => {
  const { login, logout, isAuthenticated } = useOidc();
  const { accessToken } = useOidcAccessToken();
  const {
    user,
    loading: userLoading,
    error: userError,
    refreshUser,
  } = useUser();

  const isLoading = userLoading;
  const isInitialized = isAuthenticated !== undefined && !userLoading;

  return {
    login,
    logout,
    refreshUser,

    isAuthenticated,
    isLoading,
    isInitialized,

    accessToken,
    user,
    userError,

    signIn: login,
    signOut: logout,
  };
};

export default useAuth;
